import React from "react";

const ColorSvg = ({color}: {color: string;}) => (<svg width="20" height="20" viewBox="0 0 20 20">
  <rect x="0" y="0" width="20" height="20" rx="2" fill={color}/>
</svg>);

export default ColorSvg;